/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClassifierResponse } from './ClassifierResponse';
import {
    ClassifierResponseFromJSON,
    ClassifierResponseFromJSONTyped,
    ClassifierResponseToJSON,
    ClassifierResponseToJSONTyped,
} from './ClassifierResponse';

/**
 * 
 * @export
 * @interface PersonaGroupResponse
 */
export interface PersonaGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof PersonaGroupResponse
     */
    groupId: number;
    /**
     * 
     * @type {string}
     * @memberof PersonaGroupResponse
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PersonaGroupResponse
     */
    biasIds: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PersonaGroupResponse
     */
    narrativeMappingIds: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PersonaGroupResponse
     */
    userCount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonaGroupResponse
     */
    users: Array<string>;
    /**
     * 
     * @type {ClassifierResponse}
     * @memberof PersonaGroupResponse
     */
    classifier?: ClassifierResponse | null;
}

/**
 * Check if a given object implements the PersonaGroupResponse interface.
 */
export function instanceOfPersonaGroupResponse(value: object): value is PersonaGroupResponse {
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('biasIds' in value) || value['biasIds'] === undefined) return false;
    if (!('narrativeMappingIds' in value) || value['narrativeMappingIds'] === undefined) return false;
    if (!('userCount' in value) || value['userCount'] === undefined) return false;
    if (!('users' in value) || value['users'] === undefined) return false;
    return true;
}

export function PersonaGroupResponseFromJSON(json: any): PersonaGroupResponse {
    return PersonaGroupResponseFromJSONTyped(json, false);
}

export function PersonaGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonaGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['group_id'],
        'name': json['name'],
        'biasIds': json['bias_ids'],
        'narrativeMappingIds': json['narrative_mapping_ids'],
        'userCount': json['user_count'],
        'users': json['users'],
        'classifier': json['classifier'] == null ? undefined : ClassifierResponseFromJSON(json['classifier']),
    };
}

export function PersonaGroupResponseToJSON(json: any): PersonaGroupResponse {
    return PersonaGroupResponseToJSONTyped(json, false);
}

export function PersonaGroupResponseToJSONTyped(value?: PersonaGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['groupId'],
        'name': value['name'],
        'bias_ids': value['biasIds'],
        'narrative_mapping_ids': value['narrativeMappingIds'],
        'user_count': value['userCount'],
        'users': value['users'],
        'classifier': ClassifierResponseToJSON(value['classifier']),
    };
}

